import { TrophyIcon } from '@heroicons/react/24/solid';
import { cn } from '@/utils/cn';

export const LeaderboardTableRow = ({
  data,
  rank,
}: {
  data?: {
    userName?: string;
    points?: number;
    totalPicks?: number;
    totalWinPicks?: number;
  };
  rank: number;
}) => {
  const {
    userName,
    points = 0,
    totalPicks = 0,
    totalWinPicks = 0,
  } = data ?? {};

  const isTop5Winner = rank <= 5;

  return (
    <tr className={cn(!isTop5Winner && 'bg-component-bg')}>
      <td className="rounded-tl-lg rounded-bl-lg py-4 pl-4 font-bold text-white text-xs">
        {rank}.
      </td>
      <td className="py-4">
        <div className="flex items-center gap-2">
          {userName && <MockAvatar username={userName} />}
          <span
            className={cn(
              'font-semibold',
              isTop5Winner && 'text-light-blue',
              !isTop5Winner && 'text-gray'
            )}
          >
            {userName}
          </span>
        </div>
      </td>
      <td className="py-4">{points}</td>
      <td className="py-4">
        {totalWinPicks}/{totalPicks}
      </td>
      <td className="py-4">
        {totalPicks === 0 ? 0 : Math.round((totalWinPicks / totalPicks) * 100)}%
      </td>
      <td className="rounded-tr-lg rounded-br-lg py-4">
        {isTop5Winner && <TrophyIcon className="size-4 text-gray" />}
      </td>
    </tr>
  );
};

function MockAvatar({ username }: { username: string }) {
  const firstLetterOfUserName = username.slice(0, 2).toUpperCase();
  return (
    <div
      className={cn(
        'flex h-8 w-8 items-center justify-center rounded-full bg-gray/10'
      )}
    >
      <span className="text-white text-xs">{firstLetterOfUserName}</span>
    </div>
  );
}
